import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from 'components/Header/Header';
import {
  faUser,
  faCheck,
  faTimes,
  faEdit,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { Creators } from 'store/ducks/users';
import { T, C } from 'shared/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styles from './Usuarios.module.scss';
import PropTypes from 'prop-types';
import WithPermission from 'components/Template/WithPermission/WithPermission';

const Table = ({ users = [], onDelete, onEdit }) => (
  <div className={Styles.Table}>
    <div className={Styles.TableHeader}>
      <div className={Styles.TableRow}>
        <div>
          <input type='checkbox' disabled />
        </div>
        <div>Nome</div>
        <div>Email</div>
        <div>Grupo</div>
        <div>Ativo</div>
        <div>Ações</div>
      </div>
    </div>
    <div className={Styles.TableBody}>
      {users.map(u => (
        <div className={Styles.TableRow}>
          <div>
            <input type='checkbox' />
          </div>
          <div>{u.name}</div>
          <div>{u.email}</div>
          <div>
            {T(u.roles, []).map(r => (
              <div className={Styles.Tag}>{r.name}</div>
            ))}
          </div>
          <div>
            <FontAwesomeIcon
              icon={u.status ? faCheck : faTimes}
              className={C(
                Styles.Icon,
                u.status ? Styles.Success : Styles.Failure,
              )}
            />
          </div>
          <div className={Styles.Controls}>
            <WithPermission permission='users.update'>
              <button className={Styles.Success} onClick={() => onEdit(u)}>
                <FontAwesomeIcon icon={faEdit} />
                &nbsp;Editar
              </button>
            </WithPermission>
            <WithPermission permission='users.delete'>
              <button className={Styles.Danger} onClick={() => onDelete(u)}>
                Deletar
              </button>
            </WithPermission>
          </div>
        </div>
      ))}
    </div>
  </div>
);

Table.propTypes = {
  users: PropTypes.arrayOf(PropTypes.any).isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default function Usuarios({ history }) {
  const dispatch = useDispatch();
  const users = useSelector(state => state.users.data);

  useEffect(() => {
    dispatch(Creators.getUsers());
  }, [dispatch]);

  function onEdit(user) {
    history.push('/users/' + user.id);
  }

  function onDelete(user) {
    // eslint-disable-next-line no-alert
    const confirmRemove = window.confirm('Remover o usuário ' + user.name);
    if (confirmRemove) {
      dispatch(Creators.deleteUser(user.id));
    }
  }

  function onCreate() {
    history.push('/users/create');
  }

  return (
    <div className={Styles.Page}>
      <Header title='Listagem de usuários' icon={faUser} />
      <div className={C(Styles.Content, Styles.Buttons)}>
        <WithPermission permission='users.create'>
          <button className={Styles.Success} onClick={onCreate}>
            <FontAwesomeIcon icon={faPlus} />
            &nbsp;Criar
          </button>
        </WithPermission>
      </div>
      <main className={Styles.Content}>
        <Table users={users} onDelete={onDelete} onEdit={onEdit} />
      </main>
    </div>
  );
}

Usuarios.propTypes = {
  history: PropTypes.any.isRequired,
};
